function getHubspotConsentCookie() {
    var nameEQ = "__hs_do_not_track" + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

var _hsq = window._hsq = window._hsq || [];
let hubspotConsentCookie = getHubspotConsentCookie();

function executeHubspotAnalytics() {
  hubspotConsentCookie = getHubspotConsentCookie();
  if (typeof hubspotConsentCookie !== 'undefined' && hubspotConsentCookie !== null) {
    _hsq.push(['doNotTrack', {track: true}]);
  }
}
function blockHubspotAnalytics() {
  hubspotConsentCookie = getHubspotConsentCookie();
  if (typeof hubspotConsentCookie === 'undefined' || hubspotConsentCookie === null) {
    _hsq.push(['doNotTrack']);
  }
}
function checkConsentForHubspot(adittionalChecks = 0) {
  let cpdCookie=(document.cookie.match(/^(?:.*;)?\s*cookieconsent_preferences_disabled(\s*=\s*([^;]+)?)(?:.*)?$/)||[,null])[1];
  if(cpdCookie != null) {
    if(parseInt(cpdCookie.indexOf('marketing')) === -1 && parseInt(cpdCookie.indexOf('analytics')) === -1) {
      executeHubspotAnalytics();
    } else {
      blockHubspotAnalytics();
    }
  } else {
    let gdprCache = localStorage.getItem('gdprCache') ? JSON.parse(localStorage.getItem('gdprCache')) : null;
    let gdprCacheConsentSettings = gdprCache && gdprCache.getCookieConsentSettings ? JSON.parse(gdprCache.getCookieConsentSettings) : null;
    let gdprCacheCountryDetection = gdprCache && gdprCache.countryDetection ? JSON.parse(gdprCache.countryDetection) : null;
    let ccsCookie = (document.cookie.match(/^(?:.*;)?\s*cookieconsent_status\s*=\s*([^;]+)(?:.*)?$/)||[,null])[1];
    if((gdprCacheConsentSettings || (gdprCacheCountryDetection && gdprCacheCountryDetection.disable === '1')) && !ccsCookie) {
      if((gdprCacheConsentSettings && gdprCacheConsentSettings.status === 'disabled') || gdprCacheCountryDetection.disable === '1'){
        executeHubspotAnalytics();
      } else {
        let initPreferences = parseInt(gdprCacheConsentSettings.checkboxes_behavior);
        if(initPreferences === 1 || initPreferences === 4) {
          executeHubspotAnalytics();
        } else {
          blockHubspotAnalytics();
        }
      }
    } else {
      if (adittionalChecks > 0) {
        setTimeout(function() {
          checkConsentForHubspot(adittionalChecks - 1);
        }, 1000);
      }
    }
  }
}
checkConsentForHubspot(4);
window.addEventListener('click', function (e) {
  if (e.target && typeof e.target.className === 'string' && e.target.className.indexOf('isense-cc-submit-consent') >= 0) {
    checkConsentForHubspot();
  }
});